export const generateTooltipId = (prefix = 'tooltip'): string => {
    return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
};

export const getAriaAttributes = (
    tooltipId: string,
    isVisible: boolean
) => ({
    'aria-describedby': isVisible ? tooltipId : undefined,
    'aria-expanded': isVisible,
});

export const getFocusableElements = (container: Element): Element[] => {
    const focusableSelectors = [
        'button:not([disabled])',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'a[href]',
        '[tabindex]:not([tabindex="-1"])',
        '[contenteditable="true"]',
    ].join(', ');

    return Array.from(container.querySelectorAll(focusableSelectors));
};

export const trapFocus = (container: Element, event: KeyboardEvent): void => {
    const focusableElements = getFocusableElements(container);
  
    if (focusableElements.length === 0) {return;}

    const firstElement = focusableElements[0] as HTMLElement;
    const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

    if (event.key === 'Tab') {
        if (event.shiftKey) {
            if (document.activeElement === firstElement) {
                event.preventDefault();
                lastElement.focus();
            }
        } else {
            if (document.activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        }
    }
};

export const announceToScreenReader = (message: string, priority: 'polite' | 'assertive' = 'polite'): void => {
    const announcement = document.createElement('div');
    announcement.setAttribute('aria-live', priority);
    announcement.setAttribute('aria-atomic', 'true');
    announcement.className = 'sr-only';
    announcement.textContent = message;

    document.body.appendChild(announcement);

    setTimeout(() => {
        document.body.removeChild(announcement);
    }, 1000);
};
